import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBox from "../../AdminComponents/Common/SearchBox";
import PaginationDataTable from "../../AdminComponents/Common/PaginationDataTable";
import { useNavigate } from "react-router-dom";
import Heading from "../../AdminComponents/Common/Heading";
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { theme } from "../../Assets/Theme/theme";

function Booking() {
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBookings = async () => {
      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/admin/bookings`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log(response?.data, "RESPONSE OF BOOKING");
        

        if (response.data?.success) {
          const currentDate = new Date();
          const updatedData = response.data.data
            .map((booking) => {
              const [month, day, year] = booking.date.split("/");
              const bookingDate = new Date(year, month - 1, day);

              console.log(booking?.paymentStatus, "STATUS OF BOOKING");
              

              return {
                ...booking,
                status: booking.paymentStatus, 
                canModify: booking?.paymentStatus === 'Paid',
                bookingDate,
              };
            })
            .sort((a, b) => a.bookingDate - b.bookingDate);
          setBookingData(updatedData);
          setFilteredData(updatedData);
        }
      } catch (error) {
        if (error.response?.status === 401 || error.message.includes("Authentication")) {
          navigate("/login");
        }
        console.error("Error fetching bookings:", error);
      } finally {
        setLoading(false)
      }
    };

    fetchBookings();
  }, [refresh]);

  const columns = [
    { id: "S.no", name: "S.no" },
    { id: "userName", name: "User Name" },
    { id: "userType", name: "User Type" },
    { id: "date", name: "Date" },
    { id: "participant", name: "Participant" },
    { id: "destination", name: "Destination" },
    { id: "status", name: "Status" },
    { id: "statusAction", name: "Action" },
  ];

  const [currentPage, setCurrentPage] = useState(0); 

  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchQuery(value);
    setCurrentPage(0); 
    const filtered = bookingData.filter((item) =>
      item.userName?.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  return (
    <Box>
      <Heading label={"Bookings"} />
      <Box mt={4}>
        <SearchBox
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder={"Search by name"}
        />
      </Box>
      {/* <Box>
        <PaginationDataTable
          editAndDelete={true}
          columns={columns}
          rows={bookingData}
          setRefresh={setRefresh}
        />
      </Box> */}

      <Box>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size={30} sx={{ color: theme.colors.orange }} />
          </Box>
        ) : (
          <PaginationDataTable
            editAndDelete={true}
            columns={columns}
            rows={filteredData}
            setRefresh={setRefresh}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Box>
    </Box>
  );
}

export default Booking;
